import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "deleted_spots",
    object: "user",
    header: [
      { text: "Spot", value: "address" },
      { text: "Latitud", value: "latitude" },
      { text: "Longitud", value: "longitude" },
      { text: "Tamaño", value: "size" },
      { text: "Verificado", value: "verified" },
    ],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then((response) => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
